import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { ModalContent, ModalHeading } from 'components/modal';

import { ActionContainer, ActionsContainer } from './styled';

const DeliveryDetails = () => {
  const { formatMessage } = useIntl();
  return (
    <ModalContent>
      <ModalHeading id="modal-heading">When would you like your order delivered?</ModalHeading>
      <ActionsContainer>
        <ActionContainer>
          <ActionButton variant={ActionButtonVariants.TEXT_ONLY} size={ActionButtonSizes.SMALL}>
            {formatMessage({ id: 'back' })}
          </ActionButton>
        </ActionContainer>
        <ActionContainer>
          <ActionButton>{formatMessage({ id: 'continue' })} </ActionButton>
        </ActionContainer>
      </ActionsContainer>
    </ModalContent>
  );
};

export default DeliveryDetails;
